import { Languages, isLanguage } from "../types.js";

export const computeCurrentLanguage = (i18nLanguage: string): Languages => (isLanguage(i18nLanguage) ? i18nLanguage : Languages.EN);
